import { GET_ADDCOMPLIANCE_FAILED, GET_ADDCOMPLIANCE_REQUESTED, GET_ADDCOMPLIANCE_SUCCESS, GET_ADDONBOARD_COMPLIANCE_FAILED, GET_ADDONBOARD_COMPLIANCE_REQUESTED, GET_ADDONBOARD_COMPLIANCE_SUCCESS, GET_APPROVECOMPLIANCE_FAILED, GET_APPROVECOMPLIANCE_REQUESTED, GET_APPROVECOMPLIANCE_SUCCESS, GET_COMPLIANCE_FAILED, GET_COMPLIANCE_REQUESTED, GET_COMPLIANCE_SUCCESS, GET_CONFIGCOMPLIANCE_FAILED, GET_CONFIGCOMPLIANCE_REQUESTED, GET_CONFIGCOMPLIANCE_SUCCESS, GET_COPMLIANCEVALIDATION, GET_ONBOARD_COMPLIANCE_FAILED, GET_ONBOARD_COMPLIANCE_REQUESTED, GET_ONBOARD_COMPLIANCE_SUCCESS, GET_UPDATECOMPLIANCE_FAILED, GET_UPDATECOMPLIANCE_REQUESTED, GET_UPDATECOMPLIANCE_SUCCESS } from "resources/actionTypes";


const initialState = {
  userCompliance: [],
  loading: false,
  error: null,
};
const initialStateConfig = {
  userConfigCompliance: [],
  loading: false,
  error: null,
};
const initialStateOnBoard = {
  userOnBoardCompliance: [],
  loading: false,
  error: null,
};
const initialStateAdd = {
  userAddCompliance: [],
  loading: false,
  error: null,
};
const initialStateUpdate = {
  userUpdateCompliance: [],
  loading: false,
  error: null,
};
const initialStateApprove = {
  userApproveCompliance: [],
  loading: false,
  error: null,
};
const initialStateOnboardAdd = {
  userOnBoardCompliance: [],
  loading: false,
  error: null,
};

const initialStateComplianceValidation = {
  complianceRegexValidationList: [],
  loading: false,
  error: null,
};

export function userCompliance(state = initialState, action) {
  switch (action.type) {
    case GET_COMPLIANCE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_COMPLIANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        userCompliance: action.userCompliance,
      };
    case GET_COMPLIANCE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userApproveCompliance(state = initialStateApprove, action) {
  switch (action.type) {
    case GET_APPROVECOMPLIANCE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_APPROVECOMPLIANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        userApproveCompliance: action.userApproveCompliance,
      };
    case GET_APPROVECOMPLIANCE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userConfigCompliance(state = initialStateConfig, action) {
  switch (action.type) {
    case GET_CONFIGCOMPLIANCE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_CONFIGCOMPLIANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        userConfigCompliance: action.userConfigCompliance,
      };
    case GET_CONFIGCOMPLIANCE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userOnBoardCompliance(state = initialStateOnBoard, action) {
  switch (action.type) {
    case GET_ONBOARD_COMPLIANCE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_ONBOARD_COMPLIANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        userOnBoardCompliance: action.userOnBoardCompliance,
      };
    case GET_ONBOARD_COMPLIANCE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userAddCompliance(state = initialStateAdd, action) {
  switch (action.type) {
    case GET_ADDCOMPLIANCE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_ADDCOMPLIANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        userAddCompliance: action.userAddCompliance,
      };
    case GET_ADDCOMPLIANCE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userUpdateCompliance(state = initialStateUpdate, action) {
  switch (action.type) {
    case GET_UPDATECOMPLIANCE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_UPDATECOMPLIANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        userUpdateCompliance: action.userUpdateCompliance,
      };
    case GET_UPDATECOMPLIANCE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userAddOnBoardCompliance(state = initialStateOnboardAdd, action) {
  switch (action.type) {
    case GET_ADDONBOARD_COMPLIANCE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_ADDONBOARD_COMPLIANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        userAddOnBoardCompliance: action.userAddOnBoardCompliance,
      };
    case GET_ADDONBOARD_COMPLIANCE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function getComplianceValidation(state = initialStateComplianceValidation, action) {
  switch (action.type) {
    case GET_COPMLIANCEVALIDATION.GET_COPMLIANCEVALIDATION_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_COPMLIANCEVALIDATION.GET_COPMLIANCEVALIDATION_SUCCESS:
      return {
        ...state,
        loading: false,
        complianceRegexValidationList: action.complianceRegexValidationList,
      };
    case GET_COPMLIANCEVALIDATION.GET_COPMLIANCEVALIDATION_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}
